import { render } from "./NguoiKiemNghiem.vue?vue&type=template&id=24a8deb2&scoped=true&ts=true"
import script from "./NguoiKiemNghiem.vue?vue&type=script&lang=ts"
export * from "./NguoiKiemNghiem.vue?vue&type=script&lang=ts"

import "./NguoiKiemNghiem.vue?vue&type=style&index=0&id=24a8deb2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a8deb2"]])

export default __exports__